<!-- HTML -->
<template>
  <div>
    <!-- Digital Downloads -->
    <section class="section is-medium" id="section-2">
      <div class="container is-fluid">
        <div class="columns is-mobile">
          <div class="column is-8 is-offset-4">
            <div class="album-container">
              <figure class="ghost-album">
                <img src="../../assets/img/home/the-factory-bloc-4x6.jpg" alt="An artistic image of The Factory Bloc">
              </figure>
              <figure class="album">
                <img src="../../assets/img/home/the-factory-bloc-4x6.jpg" alt="An artistic image of The Factory Bloc">
              </figure>
              <div class="text-box">
                <h1 class="title is-1">
                  The Factory Bloc
                </h1>
                <h3 class="subtitle is-3">
                  12-track album now available
                  <br>
                  on all major platforms!
                </h3>
              </div>
            </div>
          </div>
        </div>
        <div class="columns">
          <div class="column has-text-centered digi-column">
            <div class="bracket-top">
              <h5 class="subtitle is-5">
                Spotify
              </h5>
            </div>
            <a href="https://open.spotify.com/album/6e3yY1f3rIPwuFk1qhwYK5" target="_blank">
              <figure
                ref="target-0"
                class="image is-96x96 center digi-download"
              >
                <img src="../../assets/icons/digi-downloads/spotify.svg" class="sprite-top" alt="Spotify icon">
                <img src="../../assets/icons/digi-downloads/spotify.svg" class="sprite-bot" alt="Spotify icon">
              </figure>
            </a>
          <div class="bracket-bot"></div>
          </div>
  				<div class="column has-text-centered digi-column">
  					<div class="bracket-top">
  						<h5 class="subtitle is-5">
                Apple Music
              </h5>
  					</div>
  					<a href="http://itunes.apple.com/album/id/1533227822" target="_blank">
  						<figure
                ref="target-1"
                class="image is-96x96 center digi-download"
              >
  							<img src="../../assets/icons/digi-downloads/apple-music.svg" class="sprite-top" alt="Apple Music icon">
  							<img src="../../assets/icons/digi-downloads/apple-music.svg" class="sprite-bot" alt="Apple Music icon">
  						</figure>
  					</a>
  					<div class="bracket-bot"></div>
  				</div>
  				<div class="column has-text-centered digi-column">
  					<div class="bracket-top">
  						<h5 class="subtitle is-5">
                iTunes Store
              </h5>
  					</div>
  					<a href="http://itunes.apple.com/album/id1533227822?ls=1&app=itunes" target="_blank">
  						<figure
                ref="target-2"
                class="image is-96x96 center digi-download"
              >
  							<img src="../../assets/icons/digi-downloads/apple-itunes.svg" class="sprite-top" alt="iTunes Store icon">
  							<img src="../../assets/icons/digi-downloads/apple-itunes.svg" class="sprite-bot" alt="iTunes Store icon">
  						</figure>
  					</a>
  					<div class="bracket-bot"></div>
  				</div>
  			</div>
  			<div class="columns">
  				<div class="column has-text-centered digi-column">
  					<div class="bracket-top">
  						<h5 class="subtitle is-5">
                Soundcloud
              </h5>
  					</div>
  					<a href="https://soundcloud.com/jugemscloud/sets/the-factory-bloc" target="_blank">
  						<figure
                ref="target-3"
                class="image is-96x96 center digi-download"
              >
  							<img src="../../assets/icons/digi-downloads/soundcloud.svg" class="sprite-top" alt="Soundcloud icon">
  							<img src="../../assets/icons/digi-downloads/soundcloud.svg" class="sprite-bot" alt="Soundcloud icon">
  						</figure>
  					</a>
  					<div class="bracket-bot"></div>
  				</div>
  				<div class="column has-text-centered digi-column">
  					<div class="bracket-top">
  						<h5 class="subtitle is-5">
                YouTube Music
              </h5>
  					</div>
  					<a href="https://music.youtube.com/channel/UCtudEDLMyOnAnY8rTxULrpw" target="_blank">
  						<figure
                ref="target-4"
                class="image is-96x96 center digi-download"
              >
  							<img src="../../assets/icons/digi-downloads/youtube-music.svg" class="sprite-top" alt="YouTube Music icon">
  							<img src="../../assets/icons/digi-downloads/youtube-music.svg" class="sprite-bot" alt="YouTube Music icon">
  						</figure>
  					</a>
  					<div class="bracket-bot"></div>
  				</div>
  			</div>
  			<div class="columns">
  				<div class="column has-text-centered digi-column">
  					<div class="bracket-top">
  						<h5 class="subtitle is-5">
                Amazon
              </h5>
  					</div>
  					<a href="https://music.amazon.com/artists/B00OE1VUOQ/jugem's-cloud" target="_blank">
  						<figure
                ref="target-5"
                class="image is-96x96 center digi-download"
              >
  							<img src="../../assets/icons/digi-downloads/amazon.svg" class="sprite-top" alt="Amazon icon">
  							<img src="../../assets/icons/digi-downloads/amazon.svg" class="sprite-bot" alt="Amazon icon">
  						</figure>
  					</a>
  					<div class="bracket-bot"></div>
  				</div>
  				<div class="column has-text-centered digi-column">
  					<div class="bracket-top">
  						<h5 class="subtitle is-5">
                last.fm
              </h5>
  					</div>
  					<a href="https://www.last.fm/music/Jugem%27s+Cloud" target="_blank">
  						<figure
                ref="target-6"
                class="image is-96x96 center digi-download"
              >
  							<img src="../../assets/icons/digi-downloads/last-fm.svg" class="sprite-top" alt="last.fm icon">
  							<img src="../../assets/icons/digi-downloads/last-fm.svg" class="sprite-bot" alt="last.fm icon">
  						</figure>
  					</a>
  					<div class="bracket-bot"></div>
  				</div>
  				<div class="column has-text-centered digi-column">
  					<div class="bracket-top">
  						<h5 class="subtitle is-5">
                Bandcamp
              </h5>
  					</div>
  					<a href="https://jugemscloud.bandcamp.com/album/the-factory-bloc" target="_blank">
  						<figure
                ref="target-7"
                class="image is-96x96 center digi-download"
              >
  							<img src="../../assets/icons/digi-downloads/bandcamp.svg" class="sprite-top" alt="Bandcamp icon">
  							<img src="../../assets/icons/digi-downloads/bandcamp.svg" class="sprite-bot" alt="Bandcamp icon">
  						</figure>
  					</a>
  					<div class="bracket-bot"></div>
  				</div>
  				<div class="column has-text-centered digi-column">
  					<div class="bracket-top">
  						<h5 class="subtitle is-5">
                Deezer
              </h5>
  					</div>
  					<a href="https://www.deezer.com/en/" target="_blank">
  						<figure
                ref="target-8"
                class="image is-96x96 center digi-download"
              >
  							<img src="../../assets/icons/digi-downloads/deezer.svg" class="sprite-top" alt="Deezer icon">
  							<img src="../../assets/icons/digi-downloads/deezer.svg" class="sprite-bot" alt="Deezer icon">
  						</figure>
  					</a>
  					<div class="bracket-bot"></div>
  				</div>
  			</div>
  			<div class="columns">
  				<div class="column has-text-centered digi-column">
  					<div class="bracket-top">
  						<h5 class="subtitle is-5">
                Tidal
              </h5>
  					</div>
  					<a href="https://tidal.com/" target="_blank">
  						<figure
                ref="target-9"
                class="image is-96x96 center digi-download"
              >
  							<img src="../../assets/icons/digi-downloads/tidal.svg" class="sprite-top" alt="Tidal icon">
  							<img src="../../assets/icons/digi-downloads/tidal.svg" class="sprite-bot" alt="Tidal icon">
  						</figure>
  					</a>
  					<div class="bracket-bot"></div>
  				</div>
  				<div class="column has-text-centered digi-column">
  					<div class="bracket-top">
  						<h5 class="subtitle is-5">
                CD Digipak
              </h5>
  					</div>
  					<a href="https://jugemscloud.bandcamp.com/album/the-factory-bloc-2020" target="_blank">
  						<figure
                ref="target-10"
                class="image is-96x96 center digi-download"
              >
  							<img src="../../assets/icons/digi-downloads/cd.svg" class="sprite-top" alt="CD Digipak icon">
  							<img src="../../assets/icons/digi-downloads/cd.svg" class="sprite-bot" alt="CD Digipak icon">
  						</figure>
  					</a>
  					<div class="bracket-bot"></div>
  				</div>
  			</div>
  		</div>
      <HomeJumboText />
  	</section>
  </div>
</template>

<!-- JavaScript -->
<script>

import HomeJumboText from "@/components/home/HomeJumboText.vue";

export default {

  name: "HomeDigiDownload",

  components: {

    HomeJumboText

  },

  methods: {

    // Create Observer Function Constructor
    createObserver( myRoot, myRootMargin, myThreshold, myTarget, myTransitionDuration, myTransitionDelay ) { // Pass in options when called
     let observer;
     let options = {
       root: myRoot,
       rootMargin: myRootMargin,
       threshold: myThreshold
     };

     myTarget.style.transitionDuration = myTransitionDuration;
     myTarget.style.transitionDelay = myTransitionDelay;

     // Create a new IntersectionObserver with the constructor
     observer = new IntersectionObserver(this.handleIntersect, options);

     // Target HTML element that we will be watching is #box
     observer.observe(myTarget);

    },

    // Create Threshold List Function
    buildThresholdList( myNumSteps) {
      let thresholds = [];
      let numSteps = myNumSteps; // Number of steps
      for (let i=1.0; i<=numSteps; i++) {
        let ratio = i/numSteps;
        thresholds.push(ratio);
      }
      thresholds.push(0);
      return thresholds;
    },

    // Function that is run whenever the element is observed per the threshold
    // The callback function is automatically passed the intersectionObserverEntry object, which can be referenced with "entries"
    handleIntersect(entries) {

      if ( entries[0].intersectionRatio >= .9 ) {
        entries[0].target.classList.add('sprite-fade-in');
      }
      if ( entries[0].intersectionRatio < .9 ) {
        entries[0].target.classList.remove('sprite-fade-in');
      }

    },

    // Create all the Intersection Observers
    createIntersectionObservers() {

      // Variables
      let duration = "2s";
      let delay = ["0s", "0.2s", "0.4s", "0s", "0.2s", "0.4s", "0s", "0.2s", "0.4s", "0s", "0.2s"];
      let counter = 0;

      // Loop through list of $refs
      for (var property in this.$refs) {
        this.createObserver( null, '0px', this.buildThresholdList(10), this.$refs[property], duration, delay[counter] );
        counter++;
      }

    }

  },

  mounted() {

    this.createIntersectionObservers();

  }

};

</script>

<!-- CSS -->
<style lang="scss" scoped>
@import "../../assets/scss/variables.scss";

/* Section 2 */
#section-2 {
  background-color: #000; /* Fallback */
  background-image: -webkit-linear-gradient(135deg, #000, #222831); /* Safari 5.1, iOS 5.0-6.1, Chrome 10-25, Android 4.0-4.3 */
  background-image: -moz-linear-gradient(135deg, #000, #222831); /* Firefox 3.6 - 15 */
  background-image: -o-linear-gradient(135deg, #000, #222831); /* Opera 11.1 - 12 */
  background-image: linear-gradient(to right, #000, #222831); /* Opera 15+, Chrome 25+, IE 10+, Firefox 16+, Safari 6.1+, iOS 7+, Android 4.4+ */
  background-image: linear-gradient(135deg, #000, #222831);
  font-family: 'astera';
}

.album-container {
  position: relative;
  min-height: 80vh;
  margin-bottom: 6rem;
}
.album-container .ghost-album {
  position: absolute;
  opacity: .1;
}
.album-container .album {
  position: absolute;
  left: -8vw;
  top: 10vh;
  height: 90%;
  width: 90%;
  opacity: .5;
}
.album-container .text-box {
  position: absolute;
  left: -20vw;
  top: 26vh;
}
.text-box {
  padding: 2rem;
  border-top: 2px solid $green-tint-2;
  border-left: 2px solid $green-tint-2;
  background-color: rgba(0,0,0,0.8);
}
.text-box h1 {
  color: $gray-tint-2;
}
.text-box h3 {
  color: $green-tint-2;
}
@media screen and (max-width: 512px) {
  .text-box h1 {
    font-size: 1.6rem;
  }
  .text-box h3 {
    font-size: 1.4rem;
  }
  #section-2 .container {
    padding-left: 0;
    padding-right: 0;
  }
  .album-container .text-box {
    left: -30vw;
  }
}
@media all and (min-width: 513px) and (max-width: 640px) {
  .text-box h1 {
    font-size: 2.3rem;
  }
  .text-box h3 {
    font-size: 1.7rem;
  }
  #section-2 .container {
    padding-left: 0;
    padding-right: 0;
  }
  .album-container .text-box {
    left: -25vw;
  }
}

.digi-column figure {
	margin-top: 3rem;
}
h5 {
	color: $gray-tint-2;
}
.center {
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.digi-column {
	position: relative;
	margin: 2rem;
	padding-bottom: 3rem;
}
.bracket-top {
	position: absolute;
	padding: 1rem;
	border-top: 1px solid $gray;
	border-left: 1px solid $gray;
}
.bracket-bot {
	position: absolute;
	right: 0;
	padding: 1rem;
	border-bottom: 1px solid $gray;
	border-right: 1px solid $gray;
}
.digi-download {
	padding: 2rem;
	left: -100px;
	opacity: 0;
}
/* Sprites */
.sprite-top {
	position: absolute;
	clip-path: inset(0 0 50% 0);
	transition: .5s;
}
.sprite-bot {
	position: absolute;
	clip-path: inset(50% 0 0 0);
	transition: .5s;
}
.digi-download:hover > img:nth-child(1) {
	transform: translateX(-24px);
}
.digi-download:hover > img:nth-child(2) {
	transform: translateX(24px);
}
.sprite-fade-in {
	transform: translateX(100px);
	opacity: 1;
}

</style>
